import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/articles';

export default function LatestArticlesSection() {
  const featured = latestArticles[0];
  const others = latestArticles.slice(1, 6);

  return (
    <section className="w-full bg-background-200 py-16 md:py-20">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-50 leading-tight">
            最新爆料
          </h2>
          <p className="text-lg md:text-xl font-heading mt-1">
            <span className="text-foreground-300">独家追踪 · </span>
            <span className="text-accent-400">持续更新</span>
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          <Link
            to={`/article/${featured.slug}`}
            className="group relative lg:w-[45%] min-h-[420px] md:min-h-[520px] rounded-2xl overflow-hidden border border-secondary-800/40"
          >
            <img
              src={featured.coverImage}
              alt={featured.title}
              title={`爆料吃瓜 - ${featured.title}`}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-200 via-background-200/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
              <span className="text-xs text-accent-400 font-medium bg-background-950/60 px-3 py-1 rounded-full">
                {featured.category}
              </span>
              <h3 className="mt-3 text-xl md:text-2xl font-bold text-foreground-50 leading-snug group-hover:text-primary-400 transition-colors duration-200">
                {featured.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-400 line-clamp-2">
                {featured.excerpt}
              </p>
              <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                <span>{featured.publishDate}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {featured.viewCount.toLocaleString()}
                </span>
              </div>
            </div>
          </Link>

          <div className="lg:w-[55%] flex flex-col gap-4">
            {others.map((article, index) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className={`group flex flex-col sm:flex-row gap-4 rounded-2xl overflow-hidden border border-secondary-800/40 hover:border-secondary-600/60 transition-all duration-300 ${
                  index % 2 === 0 ? 'bg-accent-950/20' : 'bg-primary-950/20'
                } p-4`}
              >
                <div className="sm:w-48 h-32 sm:h-auto rounded-xl overflow-hidden flex-shrink-0">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    title={`爆料吃瓜 - ${article.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 flex flex-col justify-center py-1">
                  <span className="text-xs text-accent-400 font-medium">
                    {article.category}
                  </span>
                  <h3 className="mt-1 text-sm md:text-base font-bold text-foreground-50 leading-snug group-hover:text-primary-400 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="mt-1 text-xs md:text-sm text-foreground-500 line-clamp-1">
                    {article.excerpt}
                  </p>
                  <div className="mt-2 flex items-center gap-3 text-xs text-foreground-600">
                    <span>{article.publishDate}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.viewCount.toLocaleString()}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/mingxing-bagua"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-secondary-600 text-sm text-foreground-300 hover:border-accent-500 hover:text-accent-400 transition-all duration-200"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}